export default __webpack_public_path__ + "static/media/noUser.b7df8b23.svg";